import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const videosClient = createApiClient(
  actions["exd-storyteller-ai/videos"],
);

export const getVideos = async (user = "me", options = {}, filters = {}) => {
  const path = user === "me" ? "/" : `/user/${encodeURIComponent(user)}`;
  const response = await videosClient.get(path, filters, options);

  if (!response.ok) {
    throw new Error("Failed to fetch videos", { cause: response });
  }

  return response.data;
};

export const getVideo = async (id, options = {}) => {
  if (!id) {
    throw new Error("Video ID is required to fetch video");
  }

  const response = await videosClient.get(`/${id}`, {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch video", { cause: response });
  }

  if (response.data?.video?.urls) {
    response.data.video.urls = Array.from(
      new Map(response.data.video.urls.filter(([url]) => !!url)),
    );
  }

  return response.data?.video;
};

export const createVideo = async (videoData, options = {}) => {
  const response = await videosClient.post("/", videoData, options);

  if (!response.ok) {
    throw new Error("Failed to create video", { cause: response });
  }

  return response.data?.video;
};

export const duplicateVideo = async (id, options = {}) => {
  if (!id) {
    throw new Error("Video ID is required to duplicate video");
  }

  const response = await videosClient.post(`/${id}/duplicate`, {}, {
    timeout: 10 * 60 * 1000,
    ...options,
  });

  if (!response.ok) {
    throw new Error("Failed to duplicate video", { cause: response });
  }

  return response.data?.video;
};

export const deleteVideo = async (id, options = {}) => {
  if (!id) {
    throw new Error("Video ID is required to delete video");
  }

  const response = await videosClient.delete(`/${id}`, {}, options);

  if (!response.ok) {
    throw new Error("Failed to delete video", { cause: response });
  }

  return response.data;
};

export const updateVideo = async (id, videoData, options = {}) => {
  if (!id) {
    throw new Error("Video ID is required to update video");
  }

  const response = await videosClient.put(`/${id}`, videoData, options);

  if (!response.ok) {
    throw new Error("Failed to update video", { cause: response });
  }

  return response.data?.video;
};
